import { DriverWorkCycle } from "../common";
import { Office } from "../office";
import { DriverWorkShift } from "../operationPlans";

export type OfficeRelatedShiftAndCycle = {
  officeId: number;
  offices: Office;
  driverWorkShifts: DriverWorkShift[];
  driverWorkCycles: DriverWorkCycle[];
};

export type ShiftTimeType = {
  weekdayStartHours?: string;
  weekdayStartMinutes?: string;
  weekdayEndHours?: string;
  weekdayEndMinutes?: string;
  holidayStartHours?: string;
  holidayStartMinutes?: string;
  holidayEndHours?: string;
  holidayEndMinutes?: string;
};

export type DriverWorkShiftEdit = Partial<DriverWorkShift> &
  ShiftTimeType & {
    isMultipleHolidayVersionRequest: true;
  };

export type DriverWorkShiftError = {
  [key in keyof (DriverWorkShift & ShiftTimeType)]?: boolean;
};

export type DriverWorkShiftWithNumber = {
  number: number;
  key: string;
  shift: DriverWorkShift | null;
};

export type DriverWorkCycleWithNumberedShifts = Omit<
  DriverWorkCycle,
  "driverWorkShifts"
> & {
  driverWorkShifts?: DriverWorkShiftWithNumber[];
};

export type DriverWorkCycleEdit = Partial<DriverWorkCycleWithNumberedShifts>;
export type DriverWorkCycleError = {
  [key in keyof DriverWorkCycleEdit]?: boolean;
};

export type DriverWorkCycleSortKey = "offices.displayName";
export type DriverWorkCycleOrder = {
  [key in DriverWorkCycleSortKey]?: "asc" | "desc" | undefined;
};

export const CycleTab = "CycleTab";
export const ShiftTab = "ShiftTab";
export type Tabs = typeof CycleTab | typeof ShiftTab;

export type DriverWorkCyclesState = {
  page: number;
  order: DriverWorkCycleOrder;
  officeIds: number[];
  tab?: Tabs;
};
